<script setup lang="ts">
  import useAsyncComponentLoader from '@/composables/useAsyncComponentLoader';

  defineOptions({ name: 'CustomerTripsDatedView' });

  const { getAsyncComponentWithLoader } = useAsyncComponentLoader();

  const CustomerTripsDated = getAsyncComponentWithLoader(() => import('@/components/customerTripsPage/CustomerTripsDated.vue'));
</script>

<template>
  <CustomerTripsDated />
</template>
